import type { Camera, Scene, SceneControl, WebGLRenderer } from '@anov/3d-core'
import { lib, use } from '@anov/3d-core'

const { EffectComposer, RenderPass } = lib
const { useSubComposerFrame, useComposerFrame } = use

type InitPostEffectsOptions = {
  type: 'main' | 'sub'
  beforehooks?: () => void
  afterhooks?: () => void
  renderToScreen?: boolean
}

let clean: () => void

export const initPostEffects = (
  scene: Scene,
  renderer: WebGLRenderer,
  camera: Camera,
  options: InitPostEffectsOptions | undefined,
  sceneControl: SceneControl,
) => {
  const { type, beforehooks, afterhooks, renderToScreen = true } = options || { type: 'main' }
  const composer = new EffectComposer(renderer)
  const renderPass = new RenderPass(scene, camera)
  const func = type === 'main' ? useComposerFrame : useSubComposerFrame

  clean && clean()

  sceneControl.context.storeManagement.set('composer', composer)
  sceneControl.context.storeManagement.set('renderPass', renderPass)

  composer.addPass(renderPass)
  composer.renderToScreen = renderToScreen

  // @ts-ignore
  composer.isNeedRender = true

  const cleanEffectsframe = sceneControl
    ? func(sceneControl, () => {
      beforehooks && beforehooks()
      // @ts-ignore
      composer.isNeedRender && composer.render()
      afterhooks && afterhooks()
    })
    : (func as any)(() => {
        beforehooks && beforehooks()
        // @ts-ignore
        composer.isNeedRender && composer.render()
        afterhooks && afterhooks()
      })

  clean = () => {
    sceneControl.context.storeManagement.delete('composer')
    sceneControl.context.storeManagement.delete('renderPass')

    cleanEffectsframe()
  }

  return {
    composer,
    clean,
  }
}

export { OutlinePass, createHighSelectedTool } from './outlinePass'
export { createBloomSelectedTool } from './bloomSelect'
